const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Scorm Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Scorm} ScormContent injected to gain access to the Scorm resource
 */
app.controller('editScorm', ['Application', 'Authorization', 'Analyze', 'ScormContent', 'AdminContent', 'ScormView', 'Viewables', 'AccessHelper', 'SurveyHelper', '$scope', '$translate', '$filter', '$window', '$location', '$timeout', function(Application, Authorization, Analyze, ScormContent, AdminContent, ScormView, Viewables, AccessHelper, SurveyHelper, $scope, $translate, $filter, $window, $location, $timeout) {
    var self = this;

    var routeParameters = Application.navigation.getRouteParameters();
    self.newScorm = routeParameters.id === 'new' || !routeParameters.id;

    self.features = Application.features.flags();

    self.allowance = {
      create_scorm: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'scorm_create']], ['admin', 'creator', 'collaborator']),
      edit_scorm: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'scorm_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
      add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!self.newScorm && !self.allowance.edit_scorm) || (self.newScorm && !self.allowance.create_scorm)) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.editSaved = true;
    self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
    self.denied = false;
    self.archiveInfo = {};

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.editSaved) {
        // Allow the route change to progress
        locationChange();
        Application.messaging.clearMessages('trackstate');
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function() {
        locationChange();
        Application.messaging.clearMessages('trackstate');
      };
    });

    var trackState = self.trackState = Application.trackState.get();
    if (trackState && trackState.ttl < new Date().valueOf()) {
      trackState = self.trackState = false;
    }
    self.noPackage = self.newScorm;
    if (trackState) {
      var title = trackState.title;
      if (self.newScorm) {
        $translate('edit.scorm.track_add', title)
        .then(function(value) {
          Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
        });
      }
      if (!self.newScorm) {
        $translate('edit.scorm.track_edit', title)
        .then(function(value) {
          Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
        });
      }
    }

    var scorm = {
      tags: [],
      banner_image: null,
      self_hosted: true,
      linked_category: [],
      explore_hide: trackState ? true : false,
      allow_comments: false
    };
    scorm.privacy_collaborators = [];
    self.showCollaborators = false;
    self.activeTab = 'add';
    
    self.mediumOpts = {
      'targetBlank': true,
      'toolbar': {
        'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
      }
    };

    self.navigationDirectory = {
      'add': {
        next: 'details',
        previous: null,
        required: null
      },
      'details': {
        next: trackState ? 'settings' : 'images',
        previous: 'add',
        required: null
      },
      'images': {
        next: 'categories',
        previous: 'details',
        required: null
      },
      'categories': {
        next: 'settings',
        previous: 'images',
        required: null
      },
      'settings': {
        next: 'preview',
        previous: trackState ? 'details' : 'categories',
        required: null
      },
      'preview': {
        next: null,
        previous: 'settings',
        required: null
      }
    };

    self.nextSection = function(item) {
      var nextClicked = item ? false : true;
      var item = item ? self.navigationDirectory[item].previous : self.activeTab;
      var next = self.navigationDirectory[item].next;
      var missing = '';

      if (next) {
        if (self.newScorm || !nextClicked) {
          self.activeTab = next;
          Application.scrollTop();
          return;
        }
        self.saveProgress('next')
        .then(function() {
          self.activeTab = next;
          Application.scrollTop();
        });
      }

      // Need to display messages on error
      if (missing) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
      }
    };

    $scope.$on('$destroy', function() {
      if (self.newScorm && !self.created) {
        Viewables.archive({content: [{id: self.scorm._id, type: 'scorm'}]}).$promise
      }
    });

    self.saveProgress = function(next) {
      if (!self.scorm._id) {
        return;
      }

      self.updateIndicator = true;
      if(self.user.is_collaborator) {
        self.scorm.approval_required = true;
        self.scorm.approved = false;
      }
      return ScormContent.update({
        subresource: self.scorm._id,
        fields: 'company,user,title,description,duration,image,banner_image,images,properties,tags,linked_category,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,createdAt,updatedAt,cover_justification,featured_justification,explore_hide,self_hosted,certificate,certificate_data,allow_comments,rating_configuration,ssla_config'
      }, self.scorm).$promise.then(function(scorm) {
        Analyze.record({resource: 'modifications'}, {document: scorm._id, type: 'scorm-content'});
        Application.analyticsProvider.trackEvent('scorm_content_updated', {content: self.scorm._id, type: 'scorm-content', title: self.scorm.title});
        self.updateIndicator = false;
        if (self.newScorm || !next) {
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.scorm_savedPt1'] + ' ' + $filter('limitTo')(self.scorm.title, 25) + (self.scorm.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.scorm_savedPt2'], duration: 5});
        }
        self.editSaved = true;
        if (trackState && !next) {
          if (self.newScorm) {
            self.created = true;
            trackState.contentId = self.scorm._id;
            trackState.contentTitle = self.scorm.title;
            Application.trackState.set(trackState);
          }
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          return;
        }
        if (self.newScorm) {
          self.created = true;
          $location.path('/edit/scorm/' + self.scorm._id);
          $timeout(function() {
            Application.navigation.goTo('/view/scorm/' + self.scorm._id);
          }, 1);
        }
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        console.log('Error in scorm update: ', error);
      });
    };

    self.previewScorm = function() {
      if (!self.scorm || !self.scorm._id) {
        console.log('No scorm or scorm id was found');
        return;
      }
      ScormView.preview({
        contentid: self.scorm._id,
        userid: self.user._id
      }, function(preview) {
        $window.open(preview.preview_url.url, '_blank');
      }, function(error) {
        console.log('Error occured getting preview url', error);
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.scorm.preview_error'], duration: 5});
      });

    };

    self.createScorm = function() {
      self.saveProgress();
    };

    self.removeScorm = function(next) {
      if (!self.scorm._id) {
        return;
      }
      self.archiveInfo = {};
      self.updateIndicator = true;
      return Viewables.archive({content: [{id: self.scorm._id, type: 'scorm'}]}).$promise
      .then(function(results) {
        self.archiveInfo.results = results;
        self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
        self.updateIndicator = false;
        self.showDelete = false;
        if (self.archiveInfo.show) {
          return;
        }
        Analyze.record({resource: 'deletions'}, {document: self.scorm._id, type: 'scorm-content'});
        self.editSaved = true;
        Application.analyticsProvider.trackEvent('scorm_content_deleted', {content: self.scorm._id, type: 'scorm-content', title: self.scorm.title});
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.scorm_removed'], duration: 5});
        Application.navigation.goTo('/manage/content');
      }).catch(function(err) {
        self.editSaved = true;
        self.updateIndicator = false;
        self.showDelete = false;
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.scorm.remove_error'], duration: 5});
      });
    };

    self.exitPreview = function() {
      setTimeout(function() {
        self.nextSection('settings');
        $scope.$apply();
      }, 1);
    };

    self.goBack = function() {
      if (!self.denied || !self.backLocation) {
        Application.navigation.back();
        self.denied = true;
        return;
      }
      self.denied = true;
      var location = self.backLocation.split('/#/');
      if (location.length !== 2) {
        Application.navigation.back();
        return;
      }
      Application.navigation.goTo(location[1]);
    };

    self.packageReplaced = function() {
      Application.messaging.addMessage({duration: 10, text: 'The Scorm package was successfully replaced. Please allow a few minutes for the replacement to take full affect.', type: 'success'});
      self.nextSection();
    };

    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {survey: []},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.scorm.surveys;
        self.surveyAssociation.surveyIds.push(self.scorm.surveys[0].survey_id);
      }
    };

    self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      if (!Authorization.hasValidAuthToken()) {
        if (Application.navigation.isRouteSecure()) {
          Application.navigation.goToSignIn();
          return;
        }
      }
      if (!Authorization.getAuthToken().company.scorm) {
        Application.navigation.goToHome();
        return;
      }
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }
      if (self.newScorm) {
        self.scorm = scorm;
        if (self.user.is_collaborator) {
          self.scorm.privacy_collaborators.push(self.user._id);
          self.scorm.approval_required = true;
          self.scorm.approved = false;
        }
        self.startEditWatch();
        return;
      }

      AdminContent.get({
        subresource: routeParameters.id,
        fields: 'company,user,title,description,author,duration,package_duration,typical_time,image,banner_image,images,properties,tags,linked_category,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,createdAt,updatedAt,cover_justification,featured_justification,explore_hide,self_hosted,certificate,certificate_data,allow_comments,rating_configuration,ssla_config,surveys,partner_permissions',
        types: 'scorm'
      }, async function(data) {
        if (!data || (data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.trackNotEditable'], duration: 5});
          self.editSaved = true;
          Application.navigation.goToHome();
          return;
        }
        self.scorm = data;
        if (!self.scorm.privacy_collaborators) {
          self.scorm.privacy_collaborators = [];
        }
        if (self.scorm.privacy_collaborators.length && !self.user.is_collaborator) {
          self.showCollaborators = true;
        }
        if (!self.scorm.images) {
          self.scorm.images = {};
        }
        if (self.scorm.surveys.length) {
          self.surveyAssociation.initSurveyData();
        }
        if (self.scorm.partner_permissions) {
          self.partners.partnerPermission = self.scorm.partner_permissions;
        }
        self.startEditWatch();
        // self.nextSection();
        self.editSaved = true;
      }, function(error) {
        console.log('Error occured getting scorm-content ', routeParameters.id, error);
      });
    };

    self.startEditWatch = function() {
      $scope.$watch('scorm.scorm', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        if (oldVal && !oldVal.rating_configuration && newVal.rating_configuration) {
          return;
        }

        self.editSaved = false;
        if (self.noPackage) {
          self.nextSection();
          self.editSaved = true;
          self.noPackage = false;
        }
      }, true);

      $scope.$watch('scorm.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);
  
      $scope.$watch('scorm.surveyAssociation.surveyIds', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.scorm.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
      }, true);
      $scope.$watch('scorm.partners.partnerPermission', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.scorm.partner_permissions = newVal;
      }, true);
    };

    $translate([
      'edit.general.notification_fieldsMissing',
      'edit.general.notification_titleMissing',
      'edit.general.notification_confirmLeave',
      'modules.notifications.scorm_createdPt1',
      'modules.notifications.scorm_createdPt2',
      'modules.notifications.scorm_savedPt1',
      'modules.notifications.scorm_savedPt2',
      'modules.notifications.scorm_removed',
      'modules.notifications.scormNotEditable',
      'edit.scorm.preview_error',
      'edit.scorm.remove_error'
    ]).then(function(translations) {
      self.translations = translations;
      self.initialize();
    });
  }]);
